import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { CUSTOMER_GRID_MONITORING_LAYOUT } from './CustomerGridMonitoring';

export const CUSTOMER_GRID_MONITORING_LAYOUT_SPEC: LayoutSpec = {
  templateId: 'customerGrid',
  label: 'Customer Grid',
  id: 'customerGrid',
  dockViewLayout: CUSTOMER_GRID_MONITORING_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
